(function() {
  'use strict';

  var VERSION = 'v4-overlay-only-no-focus-guard';
  if (window.__nestCartOverlayVisibilitySync20260724 === VERSION) return;
  window.__nestCartOverlayVisibilitySync20260724 = VERSION;

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var cartObserver = null;
  var bodyObserver = null;
  var syncTimer = null;
  var openWatchTimer = null;
  var observedCartModal = null;
  var overlayClickBound = false;

  function getCartModal() {
    return document.querySelector('.cart-modal');
  }

  function getExtendModal() {
    return document.querySelector('#extend-offers-modal-iframe, #extend-learn-more-modal-iframe, iframe[id*="extend"][id*="modal"], iframe[src*="extend.com"], iframe[src*="helloextend"]');
  }

  function getCartClose(modal) {
    return modal && modal.querySelector('#cart-close-icon, [data-cart-close], .cart-close-icon, button[aria-label*="Close"], button[aria-label*="close"]');
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      rect.width > 0 &&
      rect.height > 0;
  }

  function closeCartFromOverlay(event) {
    event.preventDefault();
    var modal = getCartModal();
    if (!modal) return;

    var closeButton = getCartClose(modal);
    if (closeButton) {
      closeButton.click();
    } else {
      modal.style.display = 'none';
    }

    scheduleSync('overlay close', 40);
  }

  function getOverlay() {
    var overlay = document.querySelector('.seo-cart-page-overlay');
    if (!overlay) {
      overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'seo-cart-page-overlay';
      overlay.setAttribute('aria-label', 'Close cart');
      overlay.setAttribute('data-seo-cart-overlay', '');
      document.body.appendChild(overlay);
    }

    if (!overlayClickBound) {
      overlay.addEventListener('click', closeCartFromOverlay);
      overlayClickBound = true;
    }

    return overlay;
  }

  function recordState(reason, active, modal, overlay) {
    window.__nestCartOverlayVisibilityLast = {
      at: Date.now(),
      reason: reason,
      active: !!active,
      cartDisplay: modal ? window.getComputedStyle(modal).display : null,
      cartWidth: modal ? Math.round(modal.getBoundingClientRect().width) : 0,
      overlayOpacity: overlay ? window.getComputedStyle(overlay).opacity : null,
      bodyClass: document.body.className
    };
  }

  function setOverlayState(reason) {
    if (!document.body) return;

    var overlay = getOverlay();
    var modal = getCartModal();
    var extendOpen = isVisible(getExtendModal());
    var active = desktopQuery.matches &&
      !!modal &&
      isVisible(modal) &&
      !extendOpen &&
      !document.body.classList.contains('seo-cart-extend-pending');

    document.body.classList.toggle('seo-cart-overlay-active', active);
    recordState(reason || 'sync', active, modal, overlay);
  }

  function scheduleSync(reason, delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function() {
      setOverlayState(reason);
    }, delay || 0);
  }

  function scheduleSyncBurst(reason) {
    scheduleSync(reason, 0);
    window.setTimeout(function() { setOverlayState(reason + ' +40'); }, 40);
    window.setTimeout(function() { setOverlayState(reason + ' +120'); }, 120);
    window.setTimeout(function() { setOverlayState(reason + ' +300'); }, 300);
  }

  function startOpenWatch(reason) {
    var startedAt = Date.now();
    window.clearInterval(openWatchTimer);
    openWatchTimer = window.setInterval(function() {
      ensureCartWatch();
      setOverlayState(reason + ' watch');

      var modal = getCartModal();
      if ((modal && isVisible(modal)) || Date.now() - startedAt > 7000) {
        window.clearInterval(openWatchTimer);
        openWatchTimer = null;
        scheduleSyncBurst(reason + ' watch complete');
      }
    }, 60);
  }

  function watchCartModal() {
    var modal = getCartModal();
    if (!modal || !window.MutationObserver) return false;
    if (modal === observedCartModal && cartObserver) return true;

    if (cartObserver) cartObserver.disconnect();
    observedCartModal = modal;
    cartObserver = new MutationObserver(function() {
      scheduleSyncBurst('cart visibility mutation');
    });

    cartObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden'],
      childList: true,
      subtree: true
    });

    return true;
  }

  function ensureCartWatch() {
    if (!window.MutationObserver || bodyObserver) return;
    bodyObserver = new MutationObserver(function() {
      var previous = observedCartModal;
      if (watchCartModal() && observedCartModal !== previous) {
        scheduleSyncBurst('cart node rebound');
      }
    });

    bodyObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });

    if (watchCartModal()) {
      scheduleSyncBurst('cart watch attached');
    }
  }

  function isAddToCartTarget(target) {
    var control = target && target.closest && target.closest('button, input[type="submit"], a, [role="button"]');
    if (!control) return false;
    var label = [
      control.getAttribute('aria-label') || '',
      control.getAttribute('value') || '',
      control.textContent || ''
    ].join(' ').toLowerCase();

    return /add\s*to\s*cart|\+add|add/.test(label) &&
      !!control.closest('form[action*="/cart/add"], .product-form, .product-detail-description-right, .quickbuy-modal, .related-products-container');
  }

  function bind() {
    if (!document.body) return;

    getOverlay();
    ensureCartWatch();
    scheduleSyncBurst('initial');

    window.addEventListener('resize', function() { scheduleSyncBurst('resize'); });
    window.addEventListener('orientationchange', function() { scheduleSyncBurst('orientationchange'); });
    window.addEventListener('cart:refresh', function() { scheduleSyncBurst('cart:refresh'); });
    window.addEventListener('refreshCart', function() { scheduleSyncBurst('refreshCart'); });
    window.addEventListener('refreshAjaxCart', function() { scheduleSyncBurst('refreshAjaxCart'); });
    window.addEventListener('cart:refresh', function() { startOpenWatch('cart:refresh'); });
    window.addEventListener('refreshCart', function() { startOpenWatch('refreshCart'); });
    window.addEventListener('refreshAjaxCart', function() { startOpenWatch('refreshAjaxCart'); });
    document.addEventListener('click', function(event) {
      if (isAddToCartTarget(event.target)) startOpenWatch('add-to-cart click');
      scheduleSyncBurst('document click');
    }, true);
    document.addEventListener('submit', function(event) {
      if (event.target && event.target.matches && event.target.matches('form[action*="/cart/add"]')) {
        startOpenWatch('cart add submit');
      }
      scheduleSyncBurst('document submit');
    }, true);
    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', function() { scheduleSyncBurst('desktop query'); });
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(function() { scheduleSyncBurst('desktop query'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
